// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34yMJ","content":"styles_content__3zs5d"};